// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateTenancyExpiryRequestDTO } from '../models';
import { TenancyExpiryDTO } from '../models';
/**
 * TenancyExpiriesApi - axios parameter creator
 * @export
 */
export const TenancyExpiriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a TenancyExpiry
         * @param {string} tenancyId Tenancy id 
         * @param {CreateTenancyExpiryRequestDTO} createTenancyExpiryRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyExpiry(tenancyId: string, createTenancyExpiryRequestDTO: CreateTenancyExpiryRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling createTenancyExpiry.');
            }
            // verify required parameter 'createTenancyExpiryRequestDTO' is not null or undefined
            if (createTenancyExpiryRequestDTO === null || createTenancyExpiryRequestDTO === undefined) {
                throw new RequiredError('createTenancyExpiryRequestDTO','Required parameter createTenancyExpiryRequestDTO was null or undefined when calling createTenancyExpiry.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/expiries`
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateTenancyExpiryRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createTenancyExpiryRequestDTO !== undefined ? createTenancyExpiryRequestDTO : {}) : (createTenancyExpiryRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get TenancyExpiries For Tenancy by id
         * @param {string} tenancyId Tenancy id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTenancyId(tenancyId: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling getByTenancyId.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/expiries`
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenancyExpiriesApi - functional programming interface
 * @export
 */
export const TenancyExpiriesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create a TenancyExpiry
         * @param {string} tenancyId Tenancy id 
         * @param {CreateTenancyExpiryRequestDTO} createTenancyExpiryRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyExpiry(tenancyId: string, createTenancyExpiryRequestDTO: CreateTenancyExpiryRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyExpiryDTO> {
            const localVarAxiosArgs = TenancyExpiriesApiAxiosParamCreator(configuration).createTenancyExpiry(tenancyId, createTenancyExpiryRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get TenancyExpiries For Tenancy by id
         * @param {string} tenancyId Tenancy id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTenancyId(tenancyId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenancyExpiryDTO>> {
            const localVarAxiosArgs = TenancyExpiriesApiAxiosParamCreator(configuration).getByTenancyId(tenancyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TenancyExpiriesApi - factory interface
 * @export
 */
export const TenancyExpiriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create a TenancyExpiry
         * @param {string} tenancyId Tenancy id 
         * @param {CreateTenancyExpiryRequestDTO} createTenancyExpiryRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenancyExpiry(tenancyId: string, createTenancyExpiryRequestDTO: CreateTenancyExpiryRequestDTO, options?: any) {
            return TenancyExpiriesApiFp(configuration).createTenancyExpiry(tenancyId, createTenancyExpiryRequestDTO, options)(axios, basePath);
        },
        /**
         * Get TenancyExpiries For Tenancy by id
         * @param {string} tenancyId Tenancy id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTenancyId(tenancyId: string, options?: any) {
            return TenancyExpiriesApiFp(configuration).getByTenancyId(tenancyId, options)(axios, basePath);
        },
    };
};

/**
 * TenancyExpiriesApi - interface
 * @export
 * @interface TenancyExpiriesApi
 */
export interface TenancyExpiriesApiInterface {
    /**
     * Create a TenancyExpiry
     * @param {string} tenancyId Tenancy id 
     * @param {CreateTenancyExpiryRequestDTO} createTenancyExpiryRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyExpiriesApiInterface
     */
    createTenancyExpiry(tenancyId: string, createTenancyExpiryRequestDTO: CreateTenancyExpiryRequestDTO, options?: any): AxiosPromise<TenancyExpiryDTO>;

    /**
     * Get TenancyExpiries For Tenancy by id
     * @param {string} tenancyId Tenancy id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyExpiriesApiInterface
     */
    getByTenancyId(tenancyId: string, options?: any): AxiosPromise<Array<TenancyExpiryDTO>>;

}

/**
 * TenancyExpiriesApi - object-oriented interface
 * @export
 * @class TenancyExpiriesApi
 * @extends {BaseAPI}
 */
export class TenancyExpiriesApi extends BaseAPI implements TenancyExpiriesApiInterface {
    /**
     * Create a TenancyExpiry
     * @param {string} tenancyId Tenancy id 
     * @param {CreateTenancyExpiryRequestDTO} createTenancyExpiryRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyExpiriesApi
     */
    public createTenancyExpiry(tenancyId: string, createTenancyExpiryRequestDTO: CreateTenancyExpiryRequestDTO, options?: any) {
        return TenancyExpiriesApiFp(this.configuration).createTenancyExpiry(tenancyId, createTenancyExpiryRequestDTO, options)(this.axios, this.basePath);
    }

    /**
     * Get TenancyExpiries For Tenancy by id
     * @param {string} tenancyId Tenancy id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyExpiriesApi
     */
    public getByTenancyId(tenancyId: string, options?: any) {
        return TenancyExpiriesApiFp(this.configuration).getByTenancyId(tenancyId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for TenancyExpiriesApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create a TenancyExpiry
 * @param {string} tenancyId Tenancy id 
 * @param {CreateTenancyExpiryRequestDTO} createTenancyExpiryRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createTenancyExpiry(
    tenancyId: string,
    createTenancyExpiryRequestDTO: CreateTenancyExpiryRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyExpiryDTO> {
    const localVarAxiosArgs = TenancyExpiriesApiAxiosParamCreator(configuration).createTenancyExpiry(tenancyId, createTenancyExpiryRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get TenancyExpiries For Tenancy by id
 * @param {string} tenancyId Tenancy id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getByTenancyId(
    tenancyId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<TenancyExpiryDTO>> {
    const localVarAxiosArgs = TenancyExpiriesApiAxiosParamCreator(configuration).getByTenancyId(tenancyId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

